import React, { FunctionComponent } from 'react';
import { pathOr } from 'ramda';

type Props = {
  classes: any;
  fieldValue: Date | string;
  record?: Record<string, any>;
  options?: Record<string, unknown>;
};

const renderOfferType = (record?: Record<string, any>) => {
  const hasNearbyLocations = pathOr(false, ['hasNearbyLocations'], record);
  const hasOnlineLocations = pathOr(false, ['hasOnlineLocations'], record);
  if (hasNearbyLocations && !hasOnlineLocations) {
    return 'Nearby';
  }
  if (!hasNearbyLocations && hasOnlineLocations) {
    return 'Online';
  }
  if (hasNearbyLocations && hasOnlineLocations) {
    return 'Both';
  }
  return 'N/A';
};

const OfferType: FunctionComponent<Props> = ({ record }) => {
  return <div>{renderOfferType(record)}</div>;
};

export default OfferType;
